<template>
    <div
        @touchstart="handleTouchAppTouch"
        @click="handleTouchAppTouch"
        :class="{ 'app-wrapper': true, 'px-0': removeAppPaddingX, 'pt-4 px-4 pb-0': !removeAppPaddingX }"
        id="app"
    >
        <div id="bg-backdrop"></div>
        <transition v-if="showPage" name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <Modal></Modal>
        <Loader></Loader>
        <Cookie v-if="showLegacyCookie"></Cookie>
        <CurrentDateDebugging></CurrentDateDebugging>
        <PortalTarget name="page-slide-destination">
            <PageSliderPopup
                v-if="pageSliderPopup.show"
                @close="$store.commit('setPageSliderPopup', { show: false, data: null })"
                :pageSliderSlug="pageSliderPopup.slug"
            />
        </PortalTarget>

        <SocketReconnectModal v-if="isReconnectPopup" />

        <!-- Socket Debug Bar -->
        <template v-if="enableSocketDebugBar">
            <SocketDebugBar v-show="showSocketBar" @close="showSocketBar = false" :logs="socketLogs" />

            <a
                @click.prevent="toggleSocketDebugBar"
                class="open-socket-button fixed font-size-20"
                style="bottom: 10px; z-index: 999"
                href=""
            >
                <i class="fas fa-cog text-white"></i>
            </a>
        </template>
        <!-- Socket Debug Bar -->

        <NewsletterPopup
            v-if="showNewsletterModal"
            ref="newsletter"
            @close="$store.commit('setShowNewsletterModal', false)"
        />
        <LogoutPopup v-if="showLogoutPopup" />

        <FeideLoginModal v-if="showFeideLogin" />
    </div>
</template>

<style lang="scss">
@import './scss/app.scss';
</style>

<script>
import Modal from '@/components/Modal'
import Loader from '@/components/Loader'
import Cookie from '@/components/Cookie'
import CurrentDateDebugging from '@/components/CurrentDateDebugging'
import { mapState, mapGetters } from 'vuex'
import helper from '@/lib/helper.js'
import Background from '@/lib/background.js'
import appConfig from '@/app.config.js'
import UserService from '@/lib/user.js'
import Request from '@/lib/request.js'
import 'tippy.js/themes/light.css'
import 'tippy.js/themes/light-border.css'
import 'tippy.js/themes/google.css'
import 'tippy.js/themes/translucent.css'
import { loadLanguageAsync } from '@/i18n/index.js'
import Cookies from 'js-cookie'
import SocketDebugBar from '@/components/SocketDebugBar'
import SocketReconnectModal from '@/components/SocketReconnectModal'
import helperMixin from '@/mixins/helper'
import PageSliderPopup from '@/components/PageSliderPopup'
import NewsletterPopup from '@/components/NewsletterPopup.vue'
import LogoutPopup from '@/components/LogoutPopup'
import FeideLoginModal from '@/components/FeideLoginModal'

export default {
    components: {
        Modal,
        Loader,
        Cookie,
        CurrentDateDebugging,
        SocketDebugBar,
        SocketReconnectModal,
        PageSliderPopup,
        NewsletterPopup,
        LogoutPopup,
        FeideLoginModal
    },

    mixins: [helperMixin],

    data() {
        return {
            enableSocketDebugBar: false,
            showSocketBar: false,
            socketLogs: [],
            setting: {},
            showPage: false,
            showLegacyCookie: false
        }
    },

    created: async function () {
        await this.getLang()
        helper.setNewVh()
        this.setting = await this.$store.dispatch('fetchFrontPageSetting')
        this.setBackground(this.setting)
        this.addStyleSheetSystem()
        this.setCookieSetting(this.setting)
    },

    mounted: function () {
        const userService = new UserService(),
            request = new Request()
        if (userService.getUser()) {
            // Store provider in localStorage
            userService.setStoredProvider(userService.getUser().provider)

            const currentUser = userService.getUser(),
                payload = {
                    user_activity: 'last_visit'
                }

            if (this.isTeacherRoles) {
                payload.provider_id = currentUser.provider_id
            }

            request.post(appConfig.api.setLastActivity.replace(/__id__/, currentUser.id), payload)
        }

        // handle when enable socket debug bar
        if (window.localStorage.getItem('socket-debug') == 1) {
            this.enableSocketDebugBar = true
        }
    },

    methods: {
        handleTouchAppTouch: function () {
            if (!this.isAudioLoaded) {
                // Load sound when app was touch
                var audioDefinite = new Audio(require('@/assets/sounds/definite.mp3')),
                    audioPlucky = new Audio(require('@/assets/sounds/plucky.mp3')),
                    audioWrong = new Audio(require('@/assets/sounds/wrong.mp3')),
                    audioSilence = document.createElement('AUDIO')

                audioSilence.setAttribute('src', require('@/assets/sounds/silence.mp3'))
                document.body.appendChild(audioSilence)

                audioDefinite.load()
                audioPlucky.load()
                audioWrong.load()
                audioSilence.load()

                audioDefinite.volume = 1
                audioPlucky.volume = 1
                audioWrong.volume = 1
                audioSilence.volumn = 1

                this.$store.commit('updateAudioDefinite', audioDefinite)
                this.$store.commit('updateAudioPlucky', audioPlucky)
                this.$store.commit('updateAudioWrong', audioWrong)
                this.$store.commit('updateAudioSilence', audioSilence)
                this.$store.commit('updateIsAudioLoaded', true)
            }
        },

        setBackground(data) {
            if (data.background_type != null) {
                new Background({
                    color: data.background_color,
                    // image: data.background_image,
                    type: data.background_type,
                    navText: data.nav_text
                })

                this.$store.commit('updateFrontPageBackgroundSet', true)
            }

            this.$nextTick(() => {
                this.showPage = true
            })
        },

        async getLang() {
            const getCurrentCountry = await this.$store.dispatch('getCurrentCountry')

            this.$store.commit('setGeoLocation', getCurrentCountry.data.data)

            if (!Cookies.get('lang') && typeof Cookies.get('lang') == 'undefined') {
                let langCode
                getCurrentCountry.status === 200 ? (langCode = getCurrentCountry.data.data.code.toLowerCase()) : 'en'
                const lang = await loadLanguageAsync(langCode)
                Cookies.set('lang', lang, {
                    expires: 365
                })
            } else {
                loadLanguageAsync(Cookies.get('lang'))
            }

            if (location.pathname.indexOf('skoler') > -1) {
                Cookies.set('lang', 'no', {
                    expires: 365
                })
            }

            this.$store.commit('setShowTopRightMenu')
        },

        toggleSocketDebugBar() {
            this.showSocketBar = !this.showSocketBar
        },

        socketMessage(message) {
            const current = new Date()
            const date = [current.getFullYear(), current.getMonth() + 1, current.getDate()].join(',')
            const time = [current.getHours(), current.getMinutes()].join(':')

            return `[${date} ${time}] ${message}`
        },

        setCookieSetting(setting) {
            try {
                const { AwxCookieBanner } = window
                let cookieData = {}

                if (setting && setting.cookie_consent_setting) {
                    cookieData = setting.cookie_consent_setting

                    if (setting.cookie_consent_setting.content) {
                        cookieData = setting.cookie_consent_setting.content
                    }
                }

                this.showLegacyCookie = !cookieData.enable

                cookieData.ui.modalZIndex = 99999

                const cookieBanner = new AwxCookieBanner({
                    ...cookieData,
                    language: Cookies.get('lang'),
                    cssUrl: '/css/awx-cookie-banner.css'
                })
                cookieBanner.show()
            } catch {}
        }
    },

    computed: {
        ...mapGetters({
            fontpageSetting: 'getFrontPageSetting',
            socket: 'getSocket',
            isReconnectPopup: 'isReconnectPopup',
            systemSetting: 'getSystemSetting'
        }),

        ...mapState({
            removeAppPaddingX: state => state.removeAppPaddingX,
            backgroundColor: state => state.question.background_color,
            isAudioLoaded: state => state.isAudioLoaded,
            pageSliderPopup: state => state.pageSliderPopup,
            showNewsletterModal: state => state.showNewsletterModal,
            showLogoutPopup: state => state.showLogoutPopup,
            showFeideLogin: state => state.showFeideLogin
        })
    }
}
</script>

<style>
#bg-backdrop.fade-bottom:before {
    content: '';
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    text-align: center;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.9) 0%, rgba(0, 0, 0, 0) 70%);
}

#bg-backdrop .size-video-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    z-index: -1;
}
</style>
